<template>
  <v-app-bar
          class="custom-app-bar"
          app>
            <v-toolbar-title class="align-left" >
              <img src="~@/assets/csg-transformed.png"
                style="width:50%; " alt="CSG Logo">
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text>
              Dropdown Menu
              <v-icon>mdi-home</v-icon>
            </v-btn>
          </template>
          <v-list v-if="loggedin && company !== 'Homesite'">
            <v-list-item v-for="item in menuItems"
              :key="item.title" @click="handleMenuItemClick(item)">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>

          <v-list v-if="loggedin && company === 'Homesite'">
            <v-list-item v-for="item in menuItems3"
              :key="item.title" @click="handleMenuItemClick(item)">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
          <v-list v-if="!loggedin">
            <v-list-item v-for="item in menuItems2"
              :key="item.title" @click="handleMenuItemClick(item)">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
     </v-app-bar>
</template>
<script>
import { Auth } from 'aws-amplify';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  components: {
  },
  data: () => ({
    drawer: false,
    company: '',
    loggedin: false,
    menuItems: [
      { title: 'CSConnect' },
      { title: 'CSArchive' },
      { title: 'CSCancel' },
      { title: 'Home' },
      { title: 'Sign Out' },
      { title: 'Contact Support' },
    ],
    menuItems2: [
      { title: 'Login' },
      { title: 'Forgot Password' },
    ],
    menuItems3: [
      { title: 'Sign Out' },
      { title: 'Contact Support' },
    ]
  }),
  async mounted() {
    await this.getAttributes();
    //console.log(attributes)
    // const groups = this.user.signInUserSession.accessToken.payload['cognito:groups'] || [];
    // // eslint-disable-next-line
    // this.company = groups[0];
  },
  methods: {
    scroll(refName) {
      const element = document.getElementById(refName);
      element.scrollIntoView({ behavior: 'smooth' });
    },
    async logOut() {
      Auth.signOut();
      this.$store.commit('setAuthentication', false);
      this.setUser(null);
      this.$router.push('/');
    },
    async getAttributes() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        this.company = user.attributes['custom:companyName'];
        console.log(this.company)
        this.loggedin = true;
      } catch (e) {
        if (e.message === 'The user is not authenticated') throw e;
      }
    },
    handleMenuItemClick(item) {
      // Handle the menu item click event
      switch (item.title) {
        case 'Sign Out':
          this.logOut();
          break;
        case 'CSConnect':
          window.open(`https://mpconnect.csgsupport.com/CIS/login/${this.company}`, '_blank');
          break;
        case 'Home':
          this.$router.push('/Home');
          break;
        case 'CSArchive':
          this.$router.push('/csarchive');
          break;
        case 'CSCancel':
          this.$router.push('/cscancel');
          break;
        case 'Contact Support':
          this.$router.push('/help');
          break;
        case 'Login':
          this.$router.push('/');
          break;
        case 'Forgot Password':
          this.$router.push('/help');
          break;
        default:
          break;
      }
    },
    handleCardClick(attribute) {
      // Handle the card click event
      let route = '';
      if (attribute === 'cancel') route = 'cscancel';
      else if (attribute === 'archive') route = 'csarchive';
      this.$router.push(`/${route}`);
    },
    ...mapActions(['setUser']),
  },
  created() {
    let company = this.$route.fullPath;
    company = company.split('/');
    // eslint-disable-next-line
    company = company[1];
    this.strCompanyName = company;
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['getUser']),
    user() {
      return this.getUser;
    },
  },
};
</script>

<style>

</style>
